export const METHODS = {
  post: 'POST',
  get: 'GET',
  update: 'UPDATE',
  delete: 'DELETE',
  put: 'PUT',
  patch: 'PATCH'
};

export const ENDPOINTS = {
  organisation: {
    base: 'organisation',
    suggested: 'organisation/suggested',
    globalSuggestion: 'organisation/global-suggestion',
    feed: '/organisation/feed',
    popular: 'organisation/popular',
    getByIdUnauthorized: (id: number | string) =>
      `organisation/${id}/unauthorized`,
    getById: (id: number | string) => `organisation/${id}`,
    getDetailsById: (id: number | string) => `organisation/${id}/details`,
    getCategories: (id: number | string) => `organisation/${id}/b2c-categories`,
    getCategoryById: (id: number | string, categoryId: number | string) =>
      `organisation/${id}/category/${categoryId}`,
    subscribe: (id: number | string) =>
      `subscription/organisation/${id}/create`,
    unsubscribe: (id: number | string) =>
      `subscription/organisation/${id}/delete`,
    me: 'organisation/me',
    settings: 'organisation/settings',
    language: 'organisation/settings/language',
    settings_address: 'organisation/settings/address',
    webshop_settings: 'organisation/settings/webshop',
    webshop_logo: 'organisation/settings/webshop/logo',
    media: 'organisation/settings/media',
    avatar: 'organisation/settings/avatar',
    logo: 'organisation/settings/logo',
    banner: 'organisation/settings/banner',
    settingsProfile: 'organisation/settings/profile',
    settingsBusinessProfile: 'organisation/settings/business-profile',
    settingsSecurity: 'organisation/settings/security',
    settingsValidation: 'organisation/settings/validation',
    address: 'organisation/settings/address',
    members: 'organisation/members',
    membersPending: 'organisation/members/pending-invites',
    membersInvited: 'organisation/members/email-invites',
    member: (id: number | string) => `organisation/members/${id}`,
    inviteByEmail: 'organisation/member/invite',
    uploadMemberCsv: 'organisation/member/invite/csv',
    getMemberQrCode: 'organisation/member/invite/qr',
    organisationsByCategory: (id: number | string) =>
      `organisation/category/${id}`,
    addMerchant: '/organisation/add-merchant',
    subscribeMerchant: (id: number | string) =>
      `/organisation/merchant/${id}/subscribe`,
    unsubscribeMerchant: (id: number | string) =>
      `/organisation/merchant/${id}/unsubscribe`,
    unsubscribeMerchantsBulk: '/organisation/merchant/unsubscribe-bulk',
    merchant: '/organisation/merchant',
    merchantRequest: '/organisation/merchant/request',
    merchantById: (id: number | string) =>
      `/organisation/merchant/${id}/details`,
    merchantRequestById: (id: number | string) =>
      `/organisation/merchant/request/${id}`,
    acceptMerchantRequest: (id: number | string) =>
      `/organisation/merchant/${id}/request/accept`,
    declineMerchantRequest: (id: number | string) =>
      `/organisation/merchant/${id}/request/decline`,
    searchSuggestions: 'organisation/search-suggestion',
    allMerchants: 'organisation/search-filter/merchant',
    checkPendingMerchants: '/organisation/merchant/pending-request/check',
    retrieveCodeUregistered: '/organisation/code',
    globalSearch: '/organisation/global-search'
  },
  auth: {
    socialPrefill: 'social/prefill',
    sendOtp: 'register/user/send-otp',
    resendOtp: 'resend-otp',
    sendPhoneOtp: 'phone-otp',
    verifyOtp: 'verify-otp',
    signUpMember: 'register/user',
    signUpOrg: 'register/organisation',
    updateBusinessInfo: 'register/business-info',
    updateBusinessInfoLogo: 'register/business-info/logo',
    updateContactPerson: 'register/contact-person',
    signUpMerchant: 'register/merchant',
    checkMerchantId: (id: number | string) => `check-merchant-id/${id}`,
    checkBusinessNumber: (id: number | string) => `check-business-number/${id}`,
    updateB2CCategory: (id: number | string) =>
      `register/merchant/${id}/b2c-category`,
    resetPasswordRequest: 'reset-password/request',
    resetPassword: 'reset-password',
    changeRecoveryPhoneRequest: 'recovery/change-phone/request',
    changeRecoveryPhone: 'recovery/change-phone',
    sendRecoveryEmailOtp: 'recovery/change-email/send-otp',
    resendRecoveryEmailOtp: 'recovery/change-email/resend-otp',
    verifyRecoveryEmailOtp: 'recovery/change-email/verify-otp',
    changeEmail: 'recovery/change-email',
    changePassword: 'change-password',
    login: 'login',
    loginSocial: 'login/social',
    verifyGoogle: 'social/google-code/verify',
    verifyOrgCode: (id: number | string) => `organisation/code/${id}`,
    restrictionStatus: 'restriction/check'
  },
  api1881: {
    searchByPhone: '1881/search-by-phone',
    searchOrganisationByNumber: (id: number | string) =>
      `1881/search-by-organisation-number?organisationNumber=${id}`
  },
  category: {
    organisationCategory: 'organisation-category',
    b2cCategories: 'category/b2c-categories',
    organisationB2CCategories: 'category/organisation/b2c-categories'
  },
  benefit: {
    base: 'v2/benefit',
    popular: 'v2/benefit/popular',
    create: 'v2/benefit/create',
    organisationBenefits: 'benefit/organisation/benefits',
    merchantBenefitsForOrganisation: (id: string) =>
      `/benefit/merchant/${id}/benefits/for-organisations`,
    benefitById: (id: string) => `v2/benefit/${id}/base/details`,
    benefitByIdUnauthorized: (id: string) =>
      `benefit/${id}/details/unauthorized`,
    organisationBenefitById: (id: string) =>
      `benefit/organisation/benefit/${id}/details`,
    merchantBenefits: 'benefit/merchant/benefits',
    checkPublicBenefit: 'benefit/public/create/check',
    deactivateOrganisationBenefit: '/benefit/organisation/benefit/status',
    deactivateMerchantBenefit: '/benefit/merchant/benefit/status',
    organisationBenefitsSearch: '/benefit/organisation/benefits/search',
    merchantBenefitsSearch: '/benefit/merchant/benefits/search',
    benefitAvailability: (id: string) => `/benefit/${id}/availability`,
    edit: (id: string) => `/benefit/${id}`,
    editAddress: (id: string) => `/benefit/${id}/address`,
    uploadImage: 'benefit/upload-image',
    memberBenefitById: (id: string) => `v2/benefit/${id}/base/details`,
    merchantBenefitById: (id: string) => `v2/benefit/${id}/merchant/details`,
    redeem: '/v2/benefit/redeem',
    memberRedeemedBenefits: 'v2/benefit/redeemed',
    memberExpiredBenefits: 'v2/benefit/redeemed/expired',
    getDistributionCsv: (id: string | number) =>
      `/benefit/${id}/distribution-csv`,
    distributeToAll: 'benefit/distribute-to-all',
    merchantBenefitsStatistics: '/benefit/merchant/benefits/statistics',
    merchantBenefitsStatisticsOverall:
      '/benefit/merchant/benefits/statistics/overall',
    getMerchantBenefitStatistic: id =>
      `/benefit/merchant/benefits/${id}/statistics`,
    getMerchantBenefitTotalRedemption: id =>
      `/benefit/merchant/benefits/${id}/total-redemptions`,
    getMerchantBenefitRedemptionRate: id =>
      `/benefit/merchant/benefits/${id}/redemption-rate`,
    globalSearch: '/benefit/global-search',
    universalOrganisationBenefits: (id: number | string) =>
      `benefit/organisation/${id}/benefits/list`,
    universalMerchantBenefits: (id: number | string) =>
      `benefit/merchant/${id}/benefits/list`
  },
  nextApi: {
    setToken: '/api/set-token'
  },
  user: {
    base: 'user',
    settings: 'user/settings',
    language: 'user/settings/language',
    settingsProfile: 'user/settings/profile',
    settingsPreferences: 'user/settings/preferences',
    avatar: 'user/settings/avatar',
    me: 'user/me',
    subscriptions: 'user/subscription',
    addSubscriptions: 'user/add-subscription',
    unsubscribe: (id: number | string) =>
      `subscription/organisation/${id}/delete`,
    bulkUnsubscribe: 'subscription/delete-bulk',
    benefits: 'v2/user/benefit',
    acceptInvitation: (organisationId: number | string) =>
      `user/subscription/${organisationId}/accept`,
    declineInvitation: (organisationId: number | string) =>
      `user/subscription/${organisationId}/decline`,
    statistic: '/user/statistics',
    walkthrought: 'walkthrough',
    skipWalkthrough: 'walkthrough/skip'
  },
  notification: {
    base: 'notification',
    notificationById: (id: number | string) => `notification/${id}`,
    unreadExists: () => `notification/has-unread`
  },
  merchant: {
    base: 'merchant',
    me: 'merchant/me',
    settings: 'merchant/settings',
    language: 'merchant/settings/language',
    address: 'merchant/settings/address',
    locations: 'merchant/settings/locations',
    media: 'merchant/settings/media',
    avatar: 'merchant/settings/avatar',
    logo: 'merchant/settings/logo',
    b2c_category: 'merchant/settings/b2cCategory',
    settingsProfile: 'merchant/settings/profile',
    settingsBusinessProfile: 'merchant/settings/business-profile',
    settingsSecurity: 'merchant/settings/security',
    settingsValidation: 'merchant/settings/validation',
    searchSuggestions: 'merchant/search-suggestion',
    organisation: 'merchant/organisation',
    organisationRequest: 'merchant/organisation/request',
    orhanisationById: (id: number | string) =>
      `/merchant/organisation/${id}/details`,
    organisationRequestById: (id: number | string) =>
      `/merchant/organisation/request/${id}/details`,
    addOrganisation: 'merchant/add-organisation',
    subscribeOrganisation: (id: number | string) =>
      `merchant/organisation/${id}/subscribe`,
    unsubscribeOrganisation: (id: number | string) =>
      `merchant/organisation/${id}/unsubscribe`,
    unsubscribeOrganisationsBulk: '/merchant/organisation/unsubscribe-bulk',
    acceptOrganisationRequest: (id: number | string) =>
      `/merchant/organisation/${id}/request/accept`,
    declineOrganisationRequest: (id: number | string) =>
      `/merchant/organisation/${id}/request/decline`,
    allOrganisations: 'merchant/search-filter/organisation',
    checkPendingOrgs: 'merchant/organisation/pending-request/check'
  },
  receipts: {
    createSession: 'receipts/create-session',
    linkedCards: 'receipts/user/linked-cards',
    unenrollCard: (cardId: number | string) =>
      `receipts/card/${cardId}/unenroll`
  },
  geoapify: {
    autocomplete: 'geoapify/autocomplete'
  },
  cashback: {
    organisation: {
      balance: 'organisation/cashback/balance',
      statistics: 'organisation/cashback/statistics',

      fundsFlow: 'organisation/cashback/funds-flow',
      fundsFlowDownload: 'organisation/cashback/funds-flow/download',

      withdraw: 'organisation/cashback/withdraw',

      performance: 'organisation/cashback/performance',
      performanceByCategory: 'organisation/cashback/performance-by-category',
      benefitUsageRate: '/organisation/cashback/benefit-usage-rate',

      withdrawalHistory: 'organisation/cashback/withdrawal-history',
      withdrawalHistoryDownload:
        'organisation/cashback/withdrawal-history/download',

      overview: 'organisation/cashback/overview',
      overviewDownload: 'organisation/cashback/overview/download',
      bankAccount: 'organisation/cashback/bank-account',
      createBankAccount: 'organisation/cashback/bank-account/create',
      updateBankAccount: (id: number | string) =>
        `organisation/cashback/bank-account/${id}`
    },
    user: {
      balance: 'user/cashback/balance',
      total: 'user/cashback/total-earned',
      pending: 'user/cashback/pending',

      withdraw: 'user/cashback/withdraw',

      performance: 'user/cashback/performance',
      performanceByCategory: 'user/cashback/performance-by-category',

      withdrawalHistory: 'user/cashback/withdrawal-history',
      withdrawalHistoryDownload: 'user/cashback/withdrawal-history/download',

      overview: 'user/cashback/overview',
      usedCards: 'user/cashback/used-cards',
      overviewDownload: 'user/cashback/overview/download'
    },
    merchant: {
      statistics: 'merchant/cashback/statistics',

      redemptionRate: 'merchant/cashback/total-redeemptions',
      performance: 'merchant/cashback/performance',
      performanceByCategory: 'merchant/cashback/performance-by-category',

      invoiceHistory: 'merchant/cashback/invoice-history',
      invoiceHistoryDownload: 'merchant/cashback/invoices-history/download',
      invoice: (id: number | string) => `/merchant/cashback/invoice/${id}`,
      markInvoiceAsPaid: (id: number | string) =>
        `/merchant/cashback/invoice/${id}/mark-as-paid`,
      invoiceDownload: (id: number | string) =>
        `/merchant/cashback/invoice/${id}/breakdown/download`,
      newInvoice: `/merchant/cashback/new-invoice/notification`,

      uploadUsageCsv: 'merchant/cashback/csv-code-usage/upload',
      downloadUsageCsvExample:
        'merchant/cashback/csv-code-usage/example/download'
    }
  }
};
